module.exports = __webpack_public_path__ + "img/生物制药_02.2fbc339c.png";